import * as _ from 'lodash';
import { Component, Injector } from '@angular/core';
import { FilterByComponent } from '../abstract-filter-by.component';

@Component({
    selector: 'filters-by-has-inactive-expert',
    templateUrl: './filters-by-has-inactive-expert.component.html',
    styleUrls: ['./filters-by-has-inactive-expert.component.scss']
})
export class FiltersByHasInactiveExpertComponent extends FilterByComponent {

    public hasInactiveExpertEnabled = false;

    constructor(
        protected injector: Injector
    ) {
        super(injector);
        this.filterKey = 'has-inactive-expert';
    }

    initValue(listFilters: any) {
        if (this.filterKey in listFilters) {
            this.hasInactiveExpertEnabled = listFilters[this.filterKey];
        }
    }

    onChange() {
        if (!this.hasInactiveExpertEnabled) {
            const filters = this.serviceListings.filters;
            if (this.filterKey in filters) {
                delete filters['has-inactive-expert'];
                this.serviceListings.filters = filters;
            }
            this.isFiltersDirty.emit({ filterKey: this.filterKey, isDirty: false });
        } else {
            this.serviceListings.filters = _.extend(this.serviceListings.filters, {
                'has-inactive-expert': this.hasInactiveExpertEnabled
            });
            this.checkIsDirty(this.hasInactiveExpertEnabled, this.filterKey);
        }
        this.serviceListings.dataStoreChanged();
        this.saveFilter();
    }

    reset() {
        this.hasInactiveExpertEnabled = false;
        const filters = this.serviceListings.filters;
        delete filters[this.filterKey];
        this.serviceListings.filters = filters;
        this.isFiltersDirty.emit({ filterKey: this.filterKey, isDirty: false });
    }
}
